import { IOdataField } from './IOdataField';

export class OdataFieldNumber implements IOdataField {
  private value: number;

  constructor(value: number) {
    this.value = value;
  }

  toFieldString() {
    return `${this.value}`;
  };
}
